var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetanoLogomin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 138,
    width: 400,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: ".006%",
    x2: "100.082%",
    y1: "49.991%",
    y2: "49.991%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f07422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#af3424"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: ".008%",
    x2: "100.055%",
    y1: "49.993%",
    y2: "49.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#bdbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8aaad"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "49.96%",
    x2: "49.96%",
    y1: "5.005%",
    y2: "102.036%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#595a5c",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#646667",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#858786",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#a1a3a1",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#b6b9b5",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c9c3",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ced2cc",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#d1d5cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#424143",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#59595a",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#797b7a",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#949794",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a8ada8",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#b7bcb7",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c0c6c0",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#c3c9c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373531"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "52.872%",
    x2: "32.875%",
    y1: "45.575%",
    y2: "95.4%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e05926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb03b"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db8b27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc4026"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "-5.164%",
    x2: "95.694%",
    xlinkHref: "#a",
    y1: "84.711%",
    y2: "42.064%"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e45b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb03b"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "50.744%",
    x2: "49.943%",
    xlinkHref: "#b",
    y1: "-25.669%",
    y2: "60.753%"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "95.358%",
    x2: "-7.071%",
    xlinkHref: "#b",
    y1: "50.512%",
    y2: "47.923%"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "-8.259%",
    x2: "83.356%",
    xlinkHref: "#a",
    y1: "21.451%",
    y2: "58.014%"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#efa133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f26222"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "2.37%",
    x2: "136.391%",
    xlinkHref: "#c",
    y1: "15.426%",
    y2: "143.176%"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "5.929%",
    x2: "76.199%",
    xlinkHref: "#c",
    y1: "111.964%",
    y2: "5.938%"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "64.401%",
    x2: "44.982%",
    xlinkHref: "#b",
    y1: "81.316%",
    y2: "32.089%"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.57 38.067c10.544 0 15.401 5.657 13.402 16.009-1.014 5.199-4.173 9.63-8.595 12.06 4.218 2.251 6.336 6.595 5.057 13.276-2.268 11.345-9.874 16.563-21.098 16.563H131l11.523-57.908zm-11.823 47.236c3.997 0 6.476-1.932 7.455-6.595.98-4.664-.829-6.596-4.817-6.596h-6.336l-2.629 13.191zm4.597-24.055c3.308 0 5.567-2.327 6.326-6.265.83-4.109-.53-6.275-3.847-6.275h-6.097l-2.488 12.54zm62.284-23.18a19.736 19.736 0 01-.3 5.335 23.99 23.99 0 01-1.999 5.956h-20.488l-2.328 11.74h16.72a21.468 21.468 0 01-.3 5.474 23.242 23.242 0 01-1.889 5.624h-16.68l-2.479 12.391h21.238c.15 1.86.022 3.733-.38 5.55a20.576 20.576 0 01-1.879 5.784h-35.56l11.534-57.855zm44.354 0a23.883 23.883 0 01-.53 6.275 29.433 29.433 0 01-1.998 6.403H249.69l-8.885 44.525a36.25 36.25 0 01-7.305.726c-2.351.059-4.7-.185-6.996-.726l8.884-44.557h-13.192c-.15-2.076.005-4.165.46-6.19a27.754 27.754 0 011.999-6.403zm17.66 0a40.355 40.355 0 018.995.725l5.267 56.478c-2.475.546-5 .79-7.526.726-2.255.073-4.51-.171-6.706-.726l-.91-10.608h-17.43l-5.116 10.608a30.02 30.02 0 01-7.086.726 25.057 25.057 0 01-6.616-.726l27.713-56.457a49.674 49.674 0 019.415-.747zm-3.168 13.35a58.014 58.014 0 01-3.768 9.808l-6.316 12.871h11.443l-1.06-12.87a59.692 59.692 0 010-9.809zm39.977 17.375a95.2 95.2 0 01-1.13-15.123h-.43a147.939 147.939 0 01-2.328 16.009l-5.047 25.613a22.97 22.97 0 01-6.406.726 16.6 16.6 0 01-5.797-.726l11.223-56.456a49.076 49.076 0 019.655-.769 38.2 38.2 0 018.995.726l4.377 26.137a126.855 126.855 0 011.05 16.574h.3s.999-8.613 2.788-17.535l4.997-25.176a27.404 27.404 0 016.406-.726 18.56 18.56 0 015.877.726l-11.294 56.478a44.988 44.988 0 01-9.414.726 46.46 46.46 0 01-9.185-.726zM381.185 37c14.541 0 21.847 10.374 17.63 31.366S384.203 97 369.592 97c-14.612 0-21.718-10.085-17.55-31.078C356.179 45.164 366.653 37 381.185 37zm-2.109 11.505c-5.347 0-9.115 3.532-12.123 18.495s-.53 18.42 4.817 18.42 9.195-3.532 12.133-18.42c2.939-14.888.67-18.453-4.827-18.453z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 37.587a20.702 20.702 0 00-5.552-.577 30.688 30.688 0 00-6.062.577L333 52l11.728-.534zM381.426 37c-11.984 0-21.21 4.347-26.426 15l15.655-.65c2.367-4.043 5.175-5.234 8.655-5.234 3.48 0 5.566 1.064 6.018 4.6L400 50.093C398.756 41.381 392.017 37 381.426 37zM212.24 55.524h-15.335l2.145-9.442h18.79a18.028 18.028 0 001.833-4.79c.304-1.412.397-2.856.275-4.292h-31.953L183 59l29.276-1.46c.026-.672.014-1.345-.036-2.016zm-29.703-2.366C184.638 42.688 179.53 37 168.444 37h-24.233L138 67l35.846-1.864c4.476-2.486 7.656-6.868 8.69-11.978zm-15.05.894c-.787 3.975-3.152 6.323-6.651 6.323h-6.41l2.616-12.603h6.421c3.478 0 4.908 2.154 4.035 6.302zm85.387-5.703h13.452a23.616 23.616 0 002.099-5.732c.469-1.84.653-3.73.545-5.617h-42.34a22.486 22.486 0 00-2.098 5.732 16.426 16.426 0 00-.472 5.54h13.84L235.371 59l15.184-.697zm64.68 5.34h.326s0 1.778.06 4.559l11.06-.73-2.647-19.714a26.587 26.587 0 00-7.71-.775 34.053 34.053 0 00-8.268.775L307 59l10.152-.684c.308-2.883.403-4.626.403-4.626zm-39.107-3.868h.288a56.333 56.333 0 00-.086 8.278L292 57.373l-1.817-19.658a38.983 38.983 0 00-8.65-.696 47.916 47.916 0 00-9.056.696L262 59l13.323-.727a55.784 55.784 0 003.124-8.452z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.725 78.4a26.88 26.88 0 00-1.821-3.612c-.877-1.423-1.84-2.787-2.775-4.162-.405-.589-.857-1.207-1.243-1.894a3.278 3.278 0 01.405-3.485c7.553-10.954 6.821-21.85 4.923-28.151-2.476-8.206-10.27-16.393-20.107-22.449a111.718 111.718 0 00-20.31-9.678A91.004 91.004 0 0057.179.59a31.141 31.141 0 00-10.79-.226c-5.069.481-10.406 1.55-15.387 2.532-5.83 1.13-12.525 1.964-17.16 6.067-4.268 3.75-6.763 9.246-8.257 14.674a155.07 155.07 0 00-5 31.332A307.09 307.09 0 00.257 86.49c.198 6.116.842 12.209 1.927 18.228 1.436 7.734 3.931 15.793 8.604 22.173a21.584 21.584 0 004.432 4.506c4.374 3.22 9.924 3.779 15.136 4.27 10.126.981 20.609 4.21 30.638.824a93.876 93.876 0 007.862-2.297 134.006 134.006 0 0014.587-6.017 85.83 85.83 0 0014.298-8.628 58.63 58.63 0 0011.561-11.249 34.937 34.937 0 006.147-13.693c.126-.579.309-1.168.376-1.757a29.02 29.02 0 00-2.1-14.449zM59.23 94.92a45.737 45.737 0 01-4.875 3.19c-4.374 2.523-9.028 5.105-13.893 6.47-1.644.478-3.34.746-5.049.794-.347 0-3.651-.059-3.7-.304-6.32-35.612 0-72.107 0-72.107.453-.844 4.818-.069 5.31 0 3.827.86 7.55 2.15 11.098 3.848a57.339 57.339 0 019.577 5.035c3.71 2.523 8.17 6.685 8.671 11.505.424 4.093-.838 7.253-2.832 10.738-.703 1.227-2.043 2.748-1.811 4.27.27 1.835 1.782 3.327 2.813 4.75a18.745 18.745 0 012.303 4.123c2.794 7.136-2.284 13.674-7.612 17.688z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.712 78.384a25.697 25.697 0 00-1.82-3.602c-.877-1.433-1.85-2.797-2.784-4.18a20.994 20.994 0 01-1.242-1.924 3.328 3.328 0 01.385-3.484c7.551-10.952 6.82-21.836 4.922-28.136-2.466-8.175-10.248-16.36-20.101-22.414a111.368 111.368 0 00-20.303-9.677A91.116 91.116 0 0057.166.59 31.203 31.203 0 0046.369.365c-5.085.49-10.402 1.58-15.371 2.561-5.837 1.129-12.521 2.031-17.164 6.065-4.815 4.19-6.742 9.225-8.263 14.652A155.047 155.047 0 00.59 54.939a307.234 307.234 0 00-.337 31.54c.204 6.128.847 12.233 1.926 18.264 1.435 7.733 3.853 15.702 8.563 22.12a21.282 21.282 0 004.536 4.505c4.373 3.219 9.92 3.778 15.131 4.269 10.132.981 20.63 4.25 30.657.863 2.639-.657 5.287-1.403 7.859-2.296 4.976-1.72 9.85-3.728 14.601-6.016a86.265 86.265 0 0014.245-8.665 58.35 58.35 0 0011.558-11.247 34.953 34.953 0 006.116-13.68c.125-.58.308-1.178.385-1.767a29.096 29.096 0 00-2.119-14.445zm-10.595 30.756s-7.705 10.04-32.284 19.696c0 0-13.59 5.888-21.488 4.024-6.477-1.021-12.01-5.307-14.707-11.394 0 0-6.26-8.558-7.55-45.987 0 0 0-39.765 6.741-56.076 0 0 4.421-14.926 19.571-14.495 0 0 18.512.893 41.723 16.193 0 0 20.072 10.795 14.236 33.19a59.185 59.185 0 01-6.251 11.776 2.768 2.768 0 00.24 3.386s9.208 10.344 8.833 19.834c0 0 1.01 10.579-9.054 19.853z",
    fill: "#373531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.676 78.382a26.252 26.252 0 00-1.83-3.601c-.875-1.423-1.838-2.788-2.782-4.171a21.2 21.2 0 01-1.242-1.924 3.238 3.238 0 01.482-3.425c5.815-8.128 7.594-18.55 4.814-28.204-2.427-8.174-10.254-16.359-20.074-22.414a111.354 111.354 0 00-20.306-9.666A90.166 90.166 0 0057.141.6 30.916 30.916 0 0046.35.364c-5.055.491-10.399 1.59-15.366 2.571-5.835 1.12-12.584 1.963-17.177 6.055-5.44 4.858-6.739 9.225-8.24 14.642A155.296 155.296 0 00.586 54.947 309.909 309.909 0 00.25 86.478c.204 6.115.847 12.206 1.926 18.224 1.435 7.733 3.928 15.79 8.598 22.16a21.062 21.062 0 004.477 4.503c4.37 3.23 9.926 3.779 15.125 4.28 10.128.98 20.623 4.239 30.645.853a91.144 91.144 0 007.857-2.287 134.284 134.284 0 0014.595-6.025 85.533 85.533 0 0014.336-8.577 58.489 58.489 0 0011.554-11.276 35.11 35.11 0 006.113-13.739c.126-.579.299-1.168.366-1.757a29.214 29.214 0 00-2.166-14.455zm-9.57 32.503s-8.444 10.245-33.91 20.274c0 0-13.93 5.79-22.143 3.847-6.752-.823-12.593-5.18-15.405-11.491 0 0-6.489-8.891-7.837-47.743 0 0 0-41.315 6.99-58.205 0 0 4.467-15.142 20.218-14.72 0 0 19.323.589 43.412 16.467 0 0 21.49 11.61 15.405 34.838 0 0-1.213 4.907-5.777 11.551 0 0-1.213 1.786-.414 2.836 0 0 9.628 11.462 9.233 21.345.029.029.674 11.373-9.772 21z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.082 75.482c-.768-1.17-1.486-2.362-2.284-3.513-1.117-1.657-2.314-2.848-2.723-4.833a5.634 5.634 0 01.658-2.838c6.205-8.793 8.25-13.736 7.382-21.338-2.444-21.596-35.7-31.123-43.061-33.475-21.127-6.719-27.85 1.082-31.5 12.703A65.234 65.234 0 0037 32.003c.479-.903 4.888.16 5.386.259a62.269 62.269 0 0111.431 3.87 60.15 60.15 0 019.875 5.071c3.82 2.541 8.41 6.73 8.978 11.572.439 4.119-.858 7.305-2.913 10.808-.728 1.25-2.105 2.779-1.875 4.297.28 1.846 1.835 3.365 2.902 4.784a19.313 19.313 0 012.285 4.178c2.892 6.947-2.285 13.745-7.77 17.785a49.846 49.846 0 01-4.988 3.185c-4.509 2.531-9.296 5.131-14.314 6.501a21.045 21.045 0 01-5.207.804c-.349 0-3.63-.06-3.75-.298.838 4.496 1.596 7.582 2.075 9.21 3.46 11.91 9.376 16.713 19.95 15.88C68.928 129.103 116 114.455 116 88.711c-.07-4.953-2.254-9.22-4.918-13.23z",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.74 133.056c-9.172-6.317-12.13-17.967-13.689-27.845-.572-3.749-1.06-7.498-1.526-11.266a227.14 227.14 0 01-.806-8.442 195.14 195.14 0 01-.202-28.908c.244-3.335.52-6.661.88-9.996.478-4.37 1.008-8.738 1.803-13.067C28.522 20.84 32.562 5.982 46.918.836A15.642 15.642 0 0150.184 0C44.585.512 39.4 1.407 33.908 2.381 27.546 3.513 20.4 4.447 15.353 8.551c-5.513 4.525-7.761 9.18-9.415 14.59A142.549 142.549 0 00.445 54.628a282.492 282.492 0 000 31.712c.22 6.085.928 12.147 2.12 18.134 1.58 7.763 3.977 15.96 9.12 22.355a22.775 22.775 0 004.909 4.526c4.824 3.227 10.931 3.788 16.667 4.28 11.144.984 22.701 4.26 33.739.856-9.235 2.086-19.308 2.027-27.26-3.434z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 31.678s-.057-8.913 9.028-22.47c0 0 6.271-5.517 23.418.89 4.021 1.338 22.106 6.725 32.551 18.134 0 0 4.347 4.506 6.003 9.775L69.187 52a2.886 2.886 0 00-.095-.465c-1.235-3.771-3.638-7.016-6.836-9.23a40.242 40.242 0 00-4.146-2.783l-.411-.188a64.396 64.396 0 00-6.376-3.15S42.218 32.005 37 31.678z",
    fill: "url(#g)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 59s24.07-3.073 40.165-3.014c0 0 4.114-5.045 4.728-9.98.328-3.043-.1-6.112-1.258-9.006L69.827 49.054a8.57 8.57 0 01.11 3.415v.359C69.468 55.035 68.468 57.136 67 59z",
    fill: "url(#h)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.52 66.881s4.79-5.06 5.48-6.881l-42.013 3.672A28.057 28.057 0 0167 67.784z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.94 69.41L104 67c-.763 2.225-1.07 5.044-.846 7.784L67 74.516c.118-1.845.44-3.599.94-5.107z",
    fill: "#cc5827",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.042 67l36.365.117a21.572 21.572 0 002.751 4.38C107.264 73.141 111.32 78.722 112 82c0 0-17.015-3.242-39.703-5.49 0 0-2.212-4.597-3.478-5.889.057 0-2.146-2.375-1.777-3.621z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.944 78s22.16 1.939 42.305 5.333c0 0 3.404 7.483-4.281 16.667L67 87.193S70.596 83 68.944 78z",
    fill: "url(#k)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.01 101.164L45 123c-2.18-.601-4.13-1.635-5.665-3.002a17.396 17.396 0 01-3.44-3.64 25.751 25.751 0 01-2.523-4.485 42.21 42.21 0 01-2.225-6.424C30.482 103.038 30 101 30 101c.313.123.66.18 1.01.164z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.668 28.657s.222-4.845 4.63-11.92A96.254 96.254 0 0152 7s-5.82 1.974-9.429 8.277a57.536 57.536 0 00-4.263 9.308C37.744 26.035 37.307 27.51 37 29c0 0 .68-.496 2.668-.343z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.672 86L108 101.585s-3.413 5.829-11.603 11.99a69.49 69.49 0 01-2.572 1.883 84.095 84.095 0 01-5.366 3.444 97.591 97.591 0 01-10.153 5.316 98.57 98.57 0 01-18.004 6.204c-1.382.267-6.43 1.476-11.506-.685L37 104.067c1.78.174 3.573.139 5.347-.108 1.75-.374 4.68-.877 11.506-4.653 2.079-1.23 6.769-4.15 7.32-4.567a32.179 32.179 0 006.372-5.744A21.728 21.728 0 0069.672 86z",
    fill: "url(#n)",
    opacity: 0.85
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetanoLogomin);
export default __webpack_public_path__ + "static/media/betano_logo.min.09830f54.svg";
export { ForwardRef as ReactComponent };